import React from 'react'
import { connect } from 'react-redux'
import { useState, useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Portal } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../css/common/dropDown.scss'
import '../../css/modal.scss'
import { faCaretDown, faCaretUp, faSearch, faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import { SEARCH_ACTIVITY } from './constants'
import { ResetGlobalState, updateSelectedActivity } from '../../store/common/common_action'
import { colors, focusElemnt } from '../common/helper'
import { Driver_Name } from '../content/BranchTransfer/Lables'
import { ResetStateOfBranchReceive } from '../../store/branchTransferReceive/branchReceive_action'
import { Transfer_Type, ReceivedItem_Payment_Type, ReceivedItem_Consignment_Type, ReceivedItem_vehicleNo, ReceivedItem_ChallanNo } from '../content/BranchTransferReceive/Lables'
import { dispatchGlobalStateReset } from '../../store/cargoDispatch/dispatch_actions'
const DropDown = ({
  showActn,
  actnTxt,
  defaultvalue,
  formElement,
  width,
  type,
  label,
  field,
  data,
  value,
  props,
  action,
  Placeholder,
  searchPlaceholder,
  disabled,
  detail,
  portal = false,
  updateSelectedActivity,
  ResetGlobalState,
  ResetStateOfBranchReceive,
  idd,
  id,
  idd1,
  onKeyDown,
  nextId,
  prevId,
  autoFocus = false,
  tabIndex = undefined,
  listenClick = true,
  onClick = false,
  setAllValue,
  allValues,
  crossIconId,
  ResetDataGlobaly,
  dispatchGlobalStateReset,
  color=false,
  resetFlag=false,
  listWidth = undefined,
  ...rest
}) => {
  // const [defaultval1 , setDefaultValue1 ] = useState(defaultvalue)
  const defaultval = type === 'edit_vechicle_no' ? detail.jobVehicleNo : defaultvalue ? defaultvalue : ''
  const { common } = detail
  let { destCity,selBookingType,deliveybktId  } = { ...common }
  // console.log("getapi response", detail)
  let formattedlr = detail?.luggageDelivery
  // console.log(6666,formattedlr);
  const typeId=selBookingType?.typeId || deliveybktId
  const listData = data ? data : []
  const [showDrop, setShowDrop] = useState(false)
  const [isRecve, setisRecve] = useState(false)
  const [focus, setFocus] = useState(false)
  const [blur, setBlur] = useState(true)
  const list = listData
  const [selectedItem, setSelectedItem] = useState(defaultval)
  const [searchInput, setSearchInput] = useState('')
  const [filteredLists, setFilteredLists] = useState([])
  const [searchParams, setSearchParams] = useSearchParams()
  const [LrNumber, setLrNumber] = useState('')

  const [activeDrop, setActiveDrop] = useState(false)
  const [ModalData, setModalData] = useState({
    lrlist: { id: 'lrPopUp', lrListLabel: 'Lr Popup Model ', isSaved: false },
  })
  // const [ MannualLRNumber , setMannualLRNumber ] = useState("");
  const [cursor, setCursor] = useState(-1)
  // Adding below for portal ref and portal style
  // portal is used to display this outside the container
  const searchResultRef = useRef(null)
  const portalRef = useRef(null)
  const input1ref = useRef(null)
  const input2ref = useRef(null)
  const dropRef = useRef(null)
  const [dropPortalStyle, setDropPortalStyle] = useState({ width: 100, left: 0, top: 0, right: 'auto' })
  const suggestions = searchInput !== '' ? filteredLists : list

  useEffect(() => {
    if (id === 'imageDrop') {
      document.getElementById(id).focus()
    }
  }, [])
  useEffect(() => {
    if (showDrop) {
      input2ref.current.focus()
    }
  }, [showDrop])

  useEffect(() => {
    // setting style of portal based on parents position in the dom
    if (portal) {
      const dims = dropRef.current.getBoundingClientRect()
      const style = {}
      // style.width = dims.width;
      style.width = 'max-content'
      style.top = dims.top + window.scrollY + 34
      style.left = dims.left + window.scrollX
      setDropPortalStyle(style)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
    const input = dropRef.current
    if (input) input.setSelectionRange(cursor, cursor)
  }, [dropRef])

  const handleClickOutside = (e) => {
    // adding check of portal to be handled when clicked outside
    if (
      !(
        (dropRef && dropRef.current && dropRef.current.contains(e.target)) ||
        (portal && portalRef && portalRef.current && portalRef.current.contains(e.target))
      )
    ) {
      setShowDrop(false)
      setActiveDrop(false)
    }
  }

  const handleDrop = (e) => {
    setShowDrop(true)
    setActiveDrop(true)
  }

  const handleDropItem = (e, el) => {
    e.stopPropagation()
    setSelectedItem(el)
    rest.onSelect && rest.onSelect(el)
    setInpVal(el)
    setShowDrop(false)
  }
  const keypress = (e) => {
    if (e.key === 'Enter') {
      if (id === 'imageDrop') {
        document.getElementById(idd).focus()
      }
      // else if(id==="receivingPartyId"){
      //   document.getElementById(idd1).focus()
      // }
      // setShowDrop(false);
    }
    // else if(e.key){
    //   if(id==="imageDrop"){
    //     document.getElementById(idd).focus()
    //   }
    // }
  }

  const searchItems = (searchValue) => {
    setSearchInput(searchValue)
    if (searchInput !== '') {
      const filterDataIndexes = []
      const filterData = list.filter((item, arr, key) => {
        const status = item.toLowerCase().includes(searchValue.toLowerCase())
        if (status) {
          filterDataIndexes.push(key)
        }
        return status
      })
      setFilteredLists(filterData)
    } else {
      setFilteredLists(list)
    }
  }

  const resetItem = () => {
    setSelectedItem(defaultval)
    rest.reset && rest.reset()
  }

  const updateActivityAndNavigate = (val) => {
    updateSelectedActivity(val)
    setSearchParams({ view: val })
  }

  const setInpVal = (val) => {
    switch (type) {
      case SEARCH_ACTIVITY:
        updateActivityAndNavigate(val)
        ResetGlobalState()
        ResetStateOfBranchReceive()
        dispatchGlobalStateReset()
        break
      case Driver_Name:
        setAllValue({ ...allValues, selectedDriver: val })
        break
      case Transfer_Type:
        setAllValue({ ...allValues, TransferTypeState: val })
        break
      case ReceivedItem_Payment_Type:
        setAllValue({ ...allValues, PaymentTypeState: val })
        break
      case ReceivedItem_Consignment_Type:
        setAllValue({ ...allValues, ItemTypeState: val })
        break
      case ReceivedItem_vehicleNo:
        setAllValue({ ...allValues, VehicleNoState: val })
        break
      case ReceivedItem_ChallanNo:
        setAllValue({ ...allValues, VoucherNoState: val })
        break
      default:
        break
    }
  }

  const labelTxyt =
    field === 'compulsory' ? (
      <span>
        {label}
        <span style={{ color: 'red', paddingLeft: '5px' }}>*</span>
      </span>
    ) : (
      label
    )
  useEffect(() => {
    if (autoFocus) {
      input1ref.current.focus()
    }
  }, [])
  const focusNextElement = () => {
    focusElemnt(nextId)
  }
  const focusPrevElement = () => {
    focusElemnt(prevId)
  }

  const keyboardNavigation1 = (e) => {
    if (e.key === 'ArrowDown') {
      handleDrop(e)
    }
    if (e.key === 'ArrowUp') {
      handleDrop(e)
    }
    if (e.key === 'Escape') {
      focusPrevElement()
    }
    if (e.key === 'Enter') {
      focusNextElement()
      e.preventDefault()
    }
  }
  const scrollIntoView = (position) => {
    searchResultRef.current.parentNode.scrollTo({
      top: position,
      behavior: 'smooth',
    })
  }
  useEffect(() => {
    if (cursor < 0 || cursor > suggestions.length || !searchResultRef) {
      return () => { }
    }
    if (searchResultRef && searchResultRef.current && searchResultRef.current.children) {
      let listItems = Array.from(searchResultRef.current.children)
      listItems[cursor] && scrollIntoView(listItems[cursor].offsetTop - 40)
    }
  }, [cursor])
  const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }
  const prevFlag = usePrevious(resetFlag)
  useEffect(() => {
    if (resetFlag && resetFlag != prevFlag) {
      resetItem()
    }
  }, [resetFlag])
  const showSuggestion = (e, el) => {
    e.stopPropagation()
    setShowDrop(true)
    setActiveDrop(true)
  }
  const hideSuggestion = (e, el) => {
    setShowDrop(false)
    setActiveDrop(false)
  }
  const keyboardNavigation2 = (e) => {
    if (e.key === 'ArrowDown') {
      showDrop ? setCursor((c) => (c < suggestions.length - 1 ? c + 1 : 0)) : showSuggestion()
    }
    if (e.key === 'ArrowUp') {
      setCursor((c) => (c > 0 ? c - 1 : 0))
    }

    if (e.key === 'Escape') {
      hideSuggestion()
      input1ref.current.focus()
    }
    if (e.key === 'Enter' && cursor > -1) {
      setSelectedItem(suggestions[cursor])
      rest.onSelect && rest.onSelect(suggestions[cursor])
      setInpVal(suggestions[cursor])
      hideSuggestion()
      nextId ? focusNextElement() : input1ref.current.focus()
    }
  }
  // making this as a renderer function to be used as portal
  const dropDownRenderer = () => (
    <div className="drop--wrapper" style={!!portal ? dropPortalStyle : {width: listWidth}}>
      <div className="drop--search">
        <input
          id={id}
          type="text"
          className="search"
          placeholder={searchPlaceholder}
          value={searchInput}
          onChange={(e) => searchItems(e.target.value)}
          // onKeyDown={(e) => keypress(e)}
          onFocus={() => {
            setFocus(true)
            setBlur(false)
          }}
          onBlur={() => {
            setBlur(true)
            setFocus(false)
          }}
          autoComplete="off"
          onKeyDown={!!onKeyDown ? (e) => onKeyDown(e) : (e) => keyboardNavigation2(e)}
          // onKeyPress={(e) => keypress(e)}
          ref={input2ref}
        />
        <div className="search--icon">
          <FontAwesomeIcon icon={faSearch} color={'#777'} />
        </div>
      </div>
      <div className="drop--content scroll">
        <ul className="list-group" ref={searchResultRef}>
          {searchInput.length > 0 ? (
            filteredLists.length > 0 ? (
              filteredLists.map((el, index) => (
                <li
                  key={`drop--item_2${el}`}
                  className={`drop--item ${el === selectedItem ? 'selected' : ''} ${cursor === index ? 'highlighted' : ''}`}
                  onClick={(e) => handleDropItem(e, el)}
                >
                  <div className={`search--checkbox ${el === selectedItem ? 'checked' : ''}`}>
                    {
                      <span className="check">
                        <FontAwesomeIcon icon={faCheck} color={'#fff'} />
                      </span>
                    }
                  </div>
                  <div>{el}</div>
                </li>
              ))
            ) : (
              <div className="not--found">No results found</div>
            )
          ) : (
            list.map((el, index) => (
              <li
                key={`drop--item_2${el}`}
                className={`drop--item ${el === selectedItem ? 'selected' : ''} ${cursor === index ? 'highlighted' : ''}`}
                onClick={(e) => handleDropItem(e, el)}
              >
                <div className={`search--checkbox ${el === selectedItem ? 'checked' : ''}`}>
                  {el === selectedItem && (
                    <span className="check">
                      <FontAwesomeIcon icon={faCheck} color={'#fff'} />
                    </span>
                  )}
                </div>
                <div>{el}</div>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  )

  return (
    <div
      className={`dropdown--wrapper ${disabled ? 'disable' : ''} ${formElement === 'input' ? 'inputDropdownCustomise' : ''} ${activeDrop ? 'active' : ''
        }`}
      style={{ width: width, pointerEvents: listenClick ? 'auto' : 'none' }}
      ref={dropRef}
    >
      <input
        type="text"
        className={`inp--field ${disabled ? 'disable' : ''} ${focus ? 'active' : ''}`}
        value={value ? value : selectedItem}
        readOnly
        onClick={onClick ? (e) => onClick(e) : (e) => handleDrop()}
        onKeyDown={!!onKeyDown ? (e) => onKeyDown(e) : (e) => keyboardNavigation1(e)}
        onKeyPress={(e) => keypress(e)}
        tabIndex={tabIndex}
        id={id}
        ref={input1ref}
        style={{backgroundColor:disabled===false && color===true ===true?colors[typeId-1]:""}}  
      />
      {selectedItem && !disabled && (
        <div className="cross--icon" onClick={resetItem} id={crossIconId} style={{right:showActn?'43px':undefined}}>
          {type === SEARCH_ACTIVITY ? "" : <span className="cross">
            <FontAwesomeIcon icon={faXmark} color={'#777'} />
          </span>
          }
        </div>
      )}
      {!showActn ? (
        <div className="caret--icon">
          {showDrop ? <FontAwesomeIcon icon={faCaretUp} color={'#777'} /> : <FontAwesomeIcon icon={faCaretDown} color={'#777'} />}
        </div>
      ) : (
        <div className="actn--Txt" style={{ pointerEvents: 'none' }}>
          {actnTxt}
        </div>
      )}
      <div className={`inp--label ${focus ? 'active' : selectedItem && blur ? ' filled' : ''}`}>{labelTxyt}</div>
      {showDrop &&
        // For portal using portal value else whatever was earlier will be rendered
        // added parent class name as styles were dependent on that
        (!!portal ? (
          <Portal container={document.getElementById('root')}>
            <div className="dropdown--wrapper dropdown--wrapper--portal" ref={portalRef}>
              {dropDownRenderer()}
            </div>
          </Portal>
        ) : (
          <div className="dropdown--wrapper dropdown--wrapper--portal" ref={portalRef}>
            {dropDownRenderer()}
          </div>
        ))}
    </div>
  )
}

const mapStateToProps = (detail) => ({ detail })
const mapDispatchToProps = {
  updateSelectedActivity,
  ResetGlobalState,
  ResetStateOfBranchReceive,
  dispatchGlobalStateReset,
}
export default connect(mapStateToProps, mapDispatchToProps)(DropDown)
